import { render } from "./NavContact.vue?vue&type=template&id=a9b5e312"
import script from "./NavContact.vue?vue&type=script&lang=js"
export * from "./NavContact.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__